import { Folder } from "lucide-react";
import clsx from "clsx";
import { ValueName } from "../../ValueName";
import type { FolderListItemProps } from "./types";

export const FolderListItem = ({
  folder,
  planCount,
  isSelected,
  onSelect,
}: FolderListItemProps) => (
  <li>
    <button
      type="button"
      aria-current={isSelected}
      onClick={() => onSelect(folder.key)}
      className={clsx(
        "flex w-full items-start gap-2 rounded-md border px-2.5 py-1.5 text-left text-sm",
        isSelected
          ? "border-blue-300 bg-blue-50 font-semibold text-blue-700"
          : "border-transparent font-medium text-gray-700 hover:bg-gray-50",
      )}
    >
      <Folder size={16} className="mt-0.5 flex-shrink-0" />
      <ValueName
        name={folder.name}
        fileCode={folder.fileCode}
        className="flex-1"
      />
      <span
        className={clsx(
          "flex-shrink-0 text-xs font-medium leading-5 tabular-nums",
          isSelected ? "text-blue-700" : "text-gray-500",
        )}
      >
        {planCount}
      </span>
    </button>
  </li>
);
